import React, { PropsWithChildren } from 'react';
import { ConfigContextProvider as ConfigContext } from '@cp/shared/config';
import { useInjection } from '@cp/shared/di';
import { CONFIG_MANAGER } from 'src/shared/config';

export const ConfigContextProvider = (p: PropsWithChildren) => {
  const manager = useInjection(CONFIG_MANAGER);
  return <ConfigContext value={manager}>{p.children}</ConfigContext>;
};
